import { Slide } from "@jelly/lesson";
import theory from "../../theory";
import config from "appConfig";

const principle: Slide = {
  descriptionHtml: `An harmonic wave is propagating in air from right to left and reaches the left boundary you have chosen. Instantaneous intensity field and mean intensity can be visualized with arrows and colors, respectively. The acoustic impedance Z(x)=p(x)/v(x) is shown as a graph presenting its modulus on a logarithmic scale and its phase. See how the intensity is changing depending on the left boundary and on the frequency of the harmonic wave. The radius of the tube can be changed as well. Look at its effect on the intensity and on the impedance. \n<hr />\n <div style="display:flex;align-items:center;gap:10px">\n<i class="cil-comment-bubble-exclamation" style="font-size:21px"></i>\n<span style="font-size:10px;font-weight:700;line-height:16px">animation slowed down by 3000x, displacement multipled by 50000, medium: air, standing wave ratio: 7.32</span>\n</div>`,
  collapsibleDescription: true,
  collapsedDescriptionTextLines: 2,
  theory: theory,
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "blockContainer",
        data: {
          block: {
            type: "iframe",
            options: {
              src: `${config.IFRAMES_REACT_URL}/0109/`,
            },
          },
        },
      },
    },
  },
};

export default principle;
